import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import flatten from "lodash/flatten";
import { Table } from "../../../../components/atoms";
import {
  getVarsoUrl,
  displayVarsomePremiumLogo,
} from "../../../../common/helpers/helpers";
import ComponentPanel from "../../../../components/atoms/ComponentPanel/ComponentPanel";
import { getIsUserPremium } from "../../../../state/selectors/general.selectors";
import withErrorGuard from "../../../../HOC/withErrorGuard";

const url = getVarsoUrl(
  "https://www.fda.gov/drugs/science-and-research-drugs/table-pharmacogenomic-biomarkers-drug-labeling"
);

const tableHeaders = [
  { id: "drug", title: "Drug" },
  { id: "therapeutic_area", title: "Therapeutic Area" },
];

const getTherapeuticArea = (area, receptor) => {
  if (receptor) {
    return `${area} (${receptor})`;
  }
  if (area) {
    return area;
  }
  return "-";
};

const getCellData = (row, key) => {
  switch (key) {
    case "therapeutic_area":
      return getTherapeuticArea(row[key], row.receptor);
    default:
      return row[key] || "-";
  }
};

const getRowData = (rowData) => {
  const tableKeys = tableHeaders.map((r) => r.id);
  return tableKeys.map((key, idx) => ({
    id: `${key}-${idx}`,
    content: getCellData(rowData, key),
  }));
};

const getTableRowsToRender = (data) => {
  return flatten(
    data.map((row, index) => {
      const rowData = getRowData(row);
      return [
        {
          id: `${index}`,
          columns: rowData,
        },
      ];
    })
  );
};

const FDA = ({ data, isUserPremium }) => {
  if (isUserPremium || __IS_COMPONENTS_PORTAL__) {
    if (data && Object.keys(data || {}).length > 0) {
      const tableRows = getTableRowsToRender(data?.items);
      return (
        <div className="varsome-result" id="fda" data-testid="fda-component">
          <div className="varsome-container varsome-container__basic">
            <ComponentPanel
              version={data?.version}
              url={url}
              premiumLogo={displayVarsomePremiumLogo(false)}
              content={
                <div className="varsome-inner-container">
                  <div className="tw-overflow-y-auto">
                    <Table
                      useExpander={true}
                      headers={tableHeaders}
                      rows={tableRows}
                    />
                  </div>
                </div>
              }
              title="FDA"
            />
          </div>
        </div>
      );
    }
    return null;
  }
  return null;
};

FDA.propTypes = {
  data: PropTypes.shape({
    version: PropTypes.string,
    items: PropTypes.arrayOf(PropTypes.shape({})),
  }),
  isUserPremium: PropTypes.bool,
};

FDA.defaultProps = {
  data: null,
  isUserPremium: false,
};

const mapStateToProps = (state) => {
  return {
    isUserPremium: getIsUserPremium(state),
  };
};

export default connect(mapStateToProps, {})(withErrorGuard(FDA, "FDA", "FDA"));
